export type Feature =
    | "UseClientUserTimezone"
    | "LifetimeShortcut"
    | "EnableGAForTesting"
    | "EnableBlizzardForTesting"
    | "GlobalNav"
    | "DetectAdBlockNonProd"
    | "EnableLensMarketPlace"
    | "ShowOrgDauMau"
    | "EnableHostedLens";

export type FeatureSet = Record<Feature, boolean>;

/**
 * Currently enabled features.
 * The features can be tweaked during runtime using {@link toggleFeatureOverride}
 */
export const featureDefaults: FeatureSet = {
    DetectAdBlockNonProd: false,
    UseClientUserTimezone: false,
    LifetimeShortcut: false,
    EnableGAForTesting: false,
    EnableBlizzardForTesting: false,
    GlobalNav: true,
    EnableLensMarketPlace: true,
    ShowOrgDauMau: false,
    EnableHostedLens: false,
};

interface FeatureInfo {
    description: string;
    jira: string;
}

export const featureInfo: Record<Feature, FeatureInfo> = {
    UseClientUserTimezone: {
        description: "Client timezone in Lens Scheduler date picker",
        jira: "LOOK-85123",
    },
    LifetimeShortcut: {
        description: "Lifetime shortcut on Insights date range picker",
        jira: "CAMKIT-931",
    },
    EnableGAForTesting: {
        description: "Enable GA for testing in pre-prod and personal",
        jira: "N/A",
    },
    EnableBlizzardForTesting: {
        description: "Enable Blizzard for testing in pre-prod and personal",
        jira: "N/A",
    },
    GlobalNav: {
        description: "Global Nav from Business Manager in Top Navigation",
        jira: "CAMKIT-3226",
    },
    DetectAdBlockNonProd: {
        description: "Disable AdBlock detection",
        jira: "CAMKIT-1361",
    },
    EnableLensMarketPlace: {
        description: "Enable Lens Marketplace",
        jira: "CAMKIT-5060",
    },
    ShowOrgDauMau: {
        description: "Show Organization DAU/MAU Chart",
        jira: "CAMKIT-5226",
    },
    EnableHostedLens: {
        description: "Enable Hosted Lens",
        jira: "CAMKIT-5829",
    },
};
